<template>
  <BContainer
    fluid
  />
</template>
<script>
export default {
  name: 'VAccountantDashboard',

  middleware: ['auth', 'accountant'],

  metaInfo () {
    return {
      title: 'Dashboard'
    }
  }
}
</script>
